import {
	type PrimaryProductKey,
	PrimaryProductKeys,
	ProductKeys,
} from '../../../../../../common/constants/products';
import type { ThirdPartyConfigsBootstrap } from '../../../../../../common/constants/schemas/3p-config';
import { isUserOAuthed } from '../../../../../../controllers/oauth';

/**
 * Determines whether GitHub should be appended to the app selector dropdown.
 * Returns true when all conditions are met:
 * 1. The primary product is Jira
 * 2. GitHub is connected (user has OAuth'd)
 * 3. GitHub isn't already in the options list
 */
export const shouldAppendGitHub = ({
	existingOptionValues,
	primaryProduct,
	thirdPartyConfigs,
	hasGitHubConfig,
}: {
	existingOptionValues: string[];
	primaryProduct: PrimaryProductKey | undefined;
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	hasGitHubConfig: boolean;
}): boolean => {
	if (primaryProduct !== PrimaryProductKeys.Jira) {
		return false;
	}

	const isGitHubConnected =
		isUserOAuthed(ProductKeys.Github, thirdPartyConfigs ?? {}).userNeedsOAuth === false;

	if (!isGitHubConnected || !hasGitHubConfig) {
		return false;
	}

	const isGitHubAlreadyIncluded = existingOptionValues.includes(ProductKeys.Github);
	if (isGitHubAlreadyIncluded) {
		return false;
	}

	return true;
};
